import {Directive} from '@angular/core';
import {ValidationService} from '@sharedcommon/services/validation.service';
import {FormGroup} from '@angular/forms';

/**
 * All paged component must extends this class to have header working (menu)
 */
@Directive()
export abstract class NeqAbstractViewComponent {

  constructor(
    protected readonly validationService: ValidationService) {
  }

  /**
   * CheckIn The form in the validation service, for the check of his state
   *
   * @param form
   * @protected
   */
  protected checkInForm(form: FormGroup) {
    this.validationService.currentForm = form;
  }

}


